<template>
  <v-dialog v-model="dialogo" width="600px" height="200px" persistent scrollable>
    <v-card>
      <v-card-title>
        Escolher Loja
        <v-spacer></v-spacer>
        <v-icon @click="fechar">mdi-close</v-icon>
      </v-card-title>

      <v-card-text style="height: 300px">
        <v-list color="transparent">
          <!-- <v-subheader>REPORTS</v-subheader> -->
          <v-list-item-group v-model="selectedItem" color="primary" mandatory>
            <template v-for="(loja, index) in lojas">
              <v-list-item :key="loja.id" @click="selecionarLoja(loja)">
                <v-list-item-icon>
                  <v-icon :color="loja.cor_primaria">mdi-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="loja.nome"></v-list-item-title>
                  <v-list-item-subtitle v-text="loja.abreviacao"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="d-flex text-no-wrap">
                  <!-- <v-icon v-if="loja.id == loja_atual.id">mdi-check</v-icon> -->

                  <v-chip small color="primary" v-if="loja.id == loja_atual.id">Atual</v-chip>
                </v-list-item-action>
                <v-list-item-action>
                  <v-chip v-if="loja.padrao == 1" class="ml-1" small color="blue lighten-3">Padrão</v-chip>
                </v-list-item-action>
                <v-list-item-action>
                  <v-icon v-if="selectedItem == index">mdi-check-bold</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index < lojas.length - 1" :key="index * 100"></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="fechar">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="confirmar">Selecionar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EscolherLoja",

  data() {
    return {
      selectedItem: null,
      loja_selecionada: {},
      loja_atual: {
        id: null,
      },
      dialogo: false,
      color: null,
    };
  },

  computed: {
    lojas() {
      return this.$store.state.listas.lojas;
    },

    loja_padrao() {
      return this.$store.state.listas.lojas.find((loja) => loja.padrao == 1);
    },
  },

  async mounted() {

  },

  methods: {
    async abrir() {
      try {
        await this.listarLojas();

        // if (this.isApenasUmaLoja()) {
        //   this.selecionarLoja(this.lojas[0]);
        //   this.confirmar();
        //   return;
        // }

        let loja = this.$storage.get("loja");
        if (loja) {
          this.loja_atual = loja;
        }

        const index = this.lojas.findIndex((loja) => loja.id == this.loja_atual.id);
        
        if (index > -1) {
          this.selectedItem = index;
          this.selecionarLoja(this.lojas[index]);
        }

        this.dialogo = true;
      } catch (error) {
        console.log(error);
      }
    },

    fechar() {
      this.dialogo = false;
    },

    selecionarLoja(loja) {
      this.loja_selecionada = loja;
      this.color = loja.cor_primaria;
    },

    confirmar() {
      this.$storage.set("loja", this.loja_selecionada);
      this.setTema(this.loja_selecionada.cor_primaria);
      this.$store.commit("lojas/SET_LOJA_ATUAL", this.loja_selecionada);
      this.$cookie.setCookie("loja_id", this.loja_selecionada.id, Infinity);
      this.$router.replace({ name: "Home" }).catch(() => { });
      this.fechar();
    },

    setTema(cor) {
      this.$vuetify.theme.themes.light.primary = cor;
    },

    carregarLoja() {
      if (this.isLojaLoaded()) {
        let loja = this.$storage.get("loja");
        this.$store.commit("lojas/SET_LOJA_ATUAL", loja);
        this.$cookie.setCookie("loja_id", loja.id);
        this.setTema(loja.cor_primaria);
      } else {
        this.usarLojaPadrao();
      }
    },

    isLojaLoaded() {
      return this.$storage.has("loja"); // Está preenchido?
    },

    async listarLojas() {
      await this.$store.dispatch("listas/lojas");
      // this.lojas = await lojasApi.listarLojas();
    },

    isApenasUmaLoja() {
      return this.lojas.length == 1;
    },

    async usarLojaPadrao() {
      await this.listarLojas();
      this.selecionarLoja(this.loja_padrao);
      this.confirmar();
      // window.location.reload();
    }
  },
};
</script>

<style scoped>
.glass {
  background: rgba(255, 255, 255, 0.1) !important;
  /* background: linear-gradient(
    to right bottom,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.1)
  ) !important; */
  /* border-radius: 2rem !important; */
  z-index: 19;
  backdrop-filter: blur(1rem) !important;
}

/* .v-menu__content {
  backdrop-filter: blur(1rem) !important;
} */
</style>
